import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHero from "@/components/feature/PageHero";
import { gemWorks } from "@/mocks/doujinshi";

export default function Gems() {
  useSeo({
    title: "冷门同人志佳作 | 被低估的宝藏作品盘点",
    description:
      "同人志指南冷门佳作盘点，聚焦完成度高却尚未被广泛发现的宝藏同人作品，涵盖百合、耽美、悬疑、科幻等小众分类，带你发现惊喜与惊喜之外的感动。",
    path: "/gems",
  });

  return (
    <div className="bg-background-50">
      <Navbar />
      <PageHero
        eyebrow="Hidden Gems"
        title="冷门同人志佳作"
        desc="这些作品或许没有被广泛讨论，却在完成度、美术与叙事上毫不逊色。适合想走出舒适区、发现惊喜的你。"
        crumbs={[{ label: "冷门佳作" }]}
      />

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {gemWorks.map((g) => (
            <article key={g.id} className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-shadow hover:shadow-md">
              <div className="relative h-64 w-full overflow-hidden">
                <img src={g.image} alt={`${g.title}冷门同人志作品封面`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-full bg-secondary-950/80 px-3 py-1 text-xs text-background-50">
                  <i className="ri-award-line mr-1 text-accent-300"></i>宝藏作品
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h2 className="font-heading text-lg font-bold text-foreground-950">{g.title}</h2>
                    <p className="mt-1 text-sm font-medium text-accent-700">{g.pairing}</p>
                  </div>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{g.reason}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-background-200 pt-3">
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">{g.category}</span>
                  <span className="text-xs text-secondary-500">{g.author}</span>
                  <Link to="/category" className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-800">
                    同类型更多 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}